import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiTag2Component } from './fi-tag2.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
    imports: [CommonModule, MatIconModule, MatButtonModule],
    declarations: [FiTag2Component],
    exports: [FiTag2Component],
})
export class FiTag2Module {}
